<template>
  <div></div>
</template>

<script>
import UsersService from "@/services/users";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("currentUser", ["userUuid"]),
  },
  async mounted() {
    const document = await UsersService.getUserByUuid(this.$db, this.userUuid);
    const user = document.data();

    if (!user.otp) {
      this.$store.dispatch("currentUser/setUserPersonalData", user);
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh-token");
      localStorage.removeItem("user");

      location.href = "/verify-otp";
    }
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/auth/oauth/OAuthPage.vue